import { render, staticRenderFns } from "./back-btn-group.vue?vue&type=template&id=7dc24a3c"
import script from "./back-btn-group.vue?vue&type=script&lang=js"
export * from "./back-btn-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports